import React from "react";
import { ThreeDots } from "react-loading-icons";
import backendService from "../services.js/backendService";
import { SocketContext } from "../services.js/socket";
import ChatBubble from "./ChatBubble";

function className(...classes) {
  return classes.filter(Boolean).join(" ");
}
function Chatfeed(props) {
  const socket = React.useContext(SocketContext);
  const scrollPoint = React.useRef(null);
  const [istyping, setIstyping] = React.useState(false);
  React.useEffect(() => {
    socket.on("usertyping", (data) => {
      if (
        data?.text.length > 1 &&
        props.userInfo.participants.find((x) => x._id === data.senderId)
      ) {
        setIstyping(true);
      } else {
        setIstyping(false);
      }
    });
  }, []);
  React.useEffect(() => {
    scrollPoint?.current?.scrollIntoView({ behavior: "smooth" });
  }, [props.messages, istyping]);
  return (
    <div className="flex flex-col h-full w-full bg-trans">
      {props.messages.map((message, index) => (
        <div
          key={message?._id ? message._id : message + index}
          ref={scrollPoint}
          className="bg-trans scroll-smooth"
        >
          {message.senderId === backendService.getLoggedInUser()["_id"] ? (
            <div className="flex justify-end pb-1 sm:pb-2 mr-1 sm:mr-3 pr-2 sm:pr-5 bg-trans ">
              <ChatBubble
                message={message}
                reciever={props.reciever}
                userInfo={props.userInfo}
                getForwardMessage={props.getForwardMessage}
                getDeleteMessage={props.getDeleteMessage}
                getEditMessage={props.getEditMessage}
              />
            </div>
          ) : (
            <div className="flex  justify-start pb-1 sm:pb-2 ml-1 sm:ml-3 pl-2 sm:pl-5 bg-trans">
              <ChatBubble
                message={message}
                userInfo={props.userInfo}
                getForwardMessage={props.getForwardMessage}
                getEditMessage={props.getEditMessage}
              />
            </div>
          )}
        </div>
      ))}
      {istyping && (
        <div
          ref={scrollPoint}
          className="flex justify-start ml-3 pt-2 pl-10 mb-2"
        >
          <text className="rounded-lg bg-white flex items-center h-6 w-auto border-solid border-3 text-xs    px-1 drop-shadow-md">
            <ThreeDots className="h-4 w-5  mx-1 right-0 " fill="#0077b6" />
          </text>
        </div>
      )}
    </div>
  );
}
export default Chatfeed;
